(function () {
  'use strict';

  const nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', () => {
      nav.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  // Smooth scroll with nav offset for all anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (!href || href === '#') return;
      const target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      const navHeight = nav ? nav.offsetHeight : 0;
      const targetPos = target.getBoundingClientRect().top + window.scrollY - navHeight;
      window.scrollTo({ top: targetPos, behavior: 'smooth' });
    });
  });

  // Reveal on scroll
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) entry.target.classList.add('in');
      });
    }, { threshold: 0.12 });
    revealEls.forEach(el => io.observe(el));
  }

  // Seal reveal toggles
  document.querySelectorAll('.seal-reveal-trigger').forEach(btn => {
    btn.addEventListener('click', () => {
      const letter = document.getElementById(btn.dataset.target);
      if (letter) letter.classList.toggle('open');
    });
  });

  // Mobile menu toggle
  const menuToggle = document.querySelector('.menu-toggle');
  const navLinks = document.querySelector('.nav-links');
  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', () => {
      const isOpen = navLinks.style.display === 'flex';
      navLinks.style.display = isOpen ? 'none' : 'flex';
      if (!isOpen) {
        navLinks.style.cssText += 'position:absolute;top:100%;left:0;right:0;flex-direction:column;background:rgba(21,16,12,.97);padding:26px 48px;gap:22px;';
      }
    });
  }

  // Collage image cycling
  const collageImg = document.getElementById('collage-img');
  const collageCycler = document.getElementById('collage-cycler');
  if (collageImg && collageCycler) {
    const collageSrcs = [
      collageImg.src,
      collageCycler.dataset.collage2 || '',
      collageCycler.dataset.collage3 || ''
    ];
    let collageIdx = 0;
    window.cycleCollageImage = function () {
      collageIdx = (collageIdx + 1) % collageSrcs.length;
      collageImg.src = collageSrcs[collageIdx];
      const hint = document.querySelector('.cycle-hint');
      const labels = ['tap to see worn ↺', 'tap ↺', 'tap ↺'];
      if (hint) hint.textContent = labels[collageIdx];
    };
  }

  // Newsletter signup: optional JSON POST to a configurable endpoint
  const joinForm = document.getElementById('joinForm');
  if (joinForm) {
    const apiEndpoint = joinForm.dataset.apiEndpoint || '';

    if (apiEndpoint) {
      joinForm.addEventListener('submit', function (e) {
        e.preventDefault();

        const emailInput = joinForm.querySelector('input[type="email"][name="contact[email]"]');
        const feedback = joinForm.querySelector('.js-join-feedback');
        const note = document.getElementById('joinNote');
        const submitBtn = joinForm.querySelector('button[type="submit"]');

        if (!emailInput || !emailInput.value.trim()) {
          showJoinFeedback(feedback, 'Please enter your email address.', true);
          return;
        }

        const payload = {
          name: '',
          email: emailInput.value.trim()
        };

        if (submitBtn) {
          submitBtn.disabled = true;
          const originalText = submitBtn.textContent;
          submitBtn.textContent = 'Sealing...';
        }

        fetch(apiEndpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(response => {
            if (!response.ok) throw new Error('Signup failed');
            return response.json().catch(() => ({}));
          })
          .then(() => {
            emailInput.value = '';
            if (note) note.style.display = 'none';
            showJoinFeedback(feedback, '\u2713 Sealed. You\'ll be the first to know.', false);
          })
          .catch(() => {
            if (note) note.style.display = 'none';
            showJoinFeedback(feedback, 'Something went wrong. Please try again.', true);
          })
          .finally(() => {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Seal It';
            }
          });
      });
    }
  }

  function showJoinFeedback(el, message, isError) {
    if (!el) return;
    el.textContent = message;
    el.classList.remove('is-success', 'is-error');
    el.classList.add(isError ? 'is-error' : 'is-success');
    el.style.display = 'flex';
  }
})();